import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { isAuthTokenValid } from "../commons/AuthTokenUtils";

export const AlreadyLoggedInRoute = (props: {
  children: ReactElement;
}): ReactElement => {
  if (isAuthTokenValid()) {
    return <Navigate to="/" />;
  }
  return props.children;
};
